module.exports = __webpack_public_path__ + "img/home_todo_item2.88aa2fa3.png";